import type { Extra } from '~/utils/error'
import { ErrorWithExtra } from '~/utils/error'

export class OfflineResourceDownloadError extends ErrorWithExtra {
  constructor(message: string, extra?: Extra) {
    super('OfflineResourceDownloadError', message, extra)
  }
}
